module.exports = __webpack_public_path__ + "img/texiao-_0000s_0013_14.5632880b.png";